<template>
    <div class="timeTable content-EXM_F margin-top">
        <a href="" class="downloadFile"></a>
        <!--德育课表-->
        <div class="layout-box-white-bg-ig6pe">
            <section class="caption-container-2Ll52 padding-x simple-2S7p1"><span class="title">德育课表</span></section>
            <section class="illustrated-1fyrZ custom-intro">
                <div class="pic-cover"><img src="http://cdn.oasisedu.net/lvzpc/moreduCenter.jpg" alt=""></div>
                <div class="text-display">
                    <div class="desc">高招教育网德育、心理规划课表紧扣国家教育部《中小学德育工作指南》要求，顶级德育名师参与编制审核，将学校<br>德育目标与学生心理发展需要有机结合，助力学校更轻松高校开展德育工作，合理规划全年德育、心理主题。
                        <p>点击查看，即可一键下载课程PPT、教案等相关素材</p></div>
                </div>
            </section>
            <section class="margin-top filter">
                <div class="ewt-tab-filter"><span class="ewt-tab-filter-label">适用年级：</span>
                    <ul class="ewt-tab-filter-content" style="margin-left: 87px;">
                        <li class="ewt-tab-filter-li" v-for="(item,index) in classList" :key="index">
                            <el-button :type="getSelectGrade===item.gradeId?'primary':''"
                                       @click="getGrade(item.gradeId)">{{item.gradeName}}
                            </el-button>
                        </li>

                    </ul>
                </div>
                <div class="ewt-tab-filter"><span class="ewt-tab-filter-label">主题分类：</span>
                    <ul class="ewt-tab-filter-content" style="margin-left: 87px;">
                        <li class="ewt-tab-filter-li " v-for="(item,index) in topicList" :key="index">
                            <el-button :type="getSelectType===item.categoryId?'primary':''"
                                       @click="getCategory(item.categoryId)">{{item.categoryName}}
                            </el-button>
                        </li>
                    </ul>
                </div>
            </section>
            <section class=" course-timetable-2Sl4B commonBackground padding-medium">
                <div class="operator">
                    <span class="prev btn" @click="changeXq(1)" :class="semesterPreId===0?'disabled':''">
                        查看前一学期<i class="iconfont icon-arrow-left-circle"></i>
                    </span>
                    <h2 class="table-title">
                        {{tableTitle}}
                    </h2>
                    <span class="next btn" @click="changeXq(2)" :class="semesterNextId===0?'disabled':''">
                        <i class="iconfont icon-arrow-right-circle"></i>查看后一学期
                    </span>
                    <div @click="downloadExcel" class="export iconfont icon-xiazai">下载当前课表</div>
                </div>
                <div>
                    <el-table class="margin-medium-top table"
                              :cell-style="{'text-align':'center'}"
                              :data="tableData"
                              border
                              :span-method="objectSpanMethod"
                              :header-cell-style="headerCellStyle"
                              style="width: 100%"
                              v-loading="loading">
                        <el-table-column  label="月份">
                            <template slot-scope="scope">
                                <div  :class="scope.row.isCurrentMonth?'colorChange':''">
                                    {{scope.row.month}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column  label="月度主题">
                            <template slot-scope="scope">
                                <div :class="scope.row.isCurrentMonth?'colorChange':''">
                                    {{scope.row.monthlyTheme}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="课程主题">
                            <template slot-scope="scope">
                                <div  class="  text-left flex alignCenter" >
                                    <div class="nP" :class="scope.row.isCurrentMonth?'colorChange':''">
                                        {{scope.row.courseThemes}}
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="课程名称">
                            <template slot-scope="scope">
                                <div  class="  text-left flex alignCenter"  >
                                    <div class="nP" :class="scope.row.isCurrentMonth?'colorChange':''">
                                        {{scope.row.courseNames}}
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="内容简介">
                            <template slot-scope="scope">
                                <div class="  text-left flex alignCenter"  >
                                    <div class="nP" :class="scope.row.isCurrentMonth?'colorChange':''">
                                        {{scope.row.contentIntroduces}}
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="查看详情">
                            <template slot-scope="scope">
                                <div>
                                    <el-button type="primary" @click="lookDetaildy(scope.row.id)">查看详情 <span></span> </el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>

                </div>
            </section>
        </div>
        <common-target-router :getLocation="getLocation"></common-target-router>

    </div>
</template>

<script>
    import {deYvClassTableGrade, deYvClassTableType, deYvTable, moralEduCourseDownload} from "../../../config";

    export default {
        name: "timeTable",
        data() {
            return {
                semesterId: 0,
                semesterNextId: 0,
                semesterPreId: 0,
                tableTitle: '',
                fieldList: [
                    {slot: '查看详情'},
                    {label: '月份', prop: 'month'},
                    {label: '月度主题', prop: 'monthlyTheme'},
                    {slot: '课程主题'},
                    {slot: '课程名称'},
                    {slot: '内容简介'}
                ],
                pageObj: {
                    size: 40,
                    totla: 0,
                    currentPgae: 0,
                    func: 'func'
                },
                loading: false,
                headerCellStyle: {
                    background: 'rgb(232 248 255)',
                    color: '#666666',
                    fontWeight: 'bolder',
                    textAlign: 'center',
                },
                //获取已选择的年级
                getSelectGrade: 1,
                //获取已选择的分类
                getSelectType: 1,
                classList: [],
                topicList: [],
                tableData: [],
                //获取target要打开的页面
                getLocation: '',
                spanArr:[]
                //德育课表下载

            }
        },

        mounted() {
            this.defaultLoadGrade();
            this.defaultLoadType();
            this.lookTable();
        },
        methods: {
            lookDetaildy(id){
                this.$router.push('/classMeetingDetail?id='+id);
            },
            async downloadExcel(){
                let result=await moralEduCourseDownload(this.getSelectGrade,this.getSelectType,this.semesterId);
                if(result.status){
                    console.log(result.data);
                    let zhi= result.data;

                    const a = document.querySelector('.downloadFile');
                    a.style.display = 'none';
                    // 使用获取到的blob对象创建的url
                    a.href = zhi;
                    // 指定下载的文件名
                    a.download = this.name+'.xls';
                    a.click();
                    console.log('进来下载了');
                }else{

                }
            },
            handlerPage() {

            },
            //切换学期
            changeXq(val){
                this.semesterId=val;
                this.lookTable();
            },

            //根据年级id查出内容
            getGrade(val) {
                this.getSelectGrade = val;
                this.lookTable();
            },
            getCategory(val) {
                this.getSelectType = val;
                this.lookTable();
            },
            //默认查出年级
            async defaultLoadGrade() {
                let result = await deYvClassTableGrade();
                if (result.status) {
                    this.classList = result.data;
                } else {

                }
            },
            //默认查出德育课表分类
            async defaultLoadType() {
                let result = await deYvClassTableType();
                if (result.status) {
                    this.topicList = result.data;
                } else {
                }
            },
            //根据分类id与年级id查出表格的内容
            async lookTable() {
                let result = await deYvTable(this.getSelectGrade, this.getSelectType,this.semesterId);
                this.loading = true;
                if (result.status) {
                    this.tableTitle = result.data.semesterTitle;
                    this.semesterNextId = result.data.semesterNextId;
                    this.semesterPreId = result.data.semesterPreId;
                    this.semesterId = result.data.semesterId;
                    // console.log(this.semesterId);
                    let contactDot = 0;
                    this.spanArr=[];
                    result.data.courseList.forEach((item,index) => {
                        if (index === 0) {
                            this.spanArr.push(1);
                        } else {
                            if (item.month ===  result.data.courseList[index - 1].month) {
                                this.spanArr[contactDot] += 1;
                                this.spanArr.push(0);
                            } else {
                                this.spanArr.push(1);
                                contactDot = index;
                            }
                        }
                    })
                    this.tableData = result.data.courseList;
                    this.loading = false;
                    console.log(result.data);

                } else {
                    this.loading = false;
                }
            },
            objectSpanMethod({row, column, rowIndex, columnIndex}) {
                console.log('进来了');
                if(columnIndex === 0||columnIndex===1 ){
                    const _row = this.spanArr[rowIndex];
                    const _col = _row>0?1:0;
                    return{
                        rowspan:_row,
                        colspan:_col
                    }
                }
            },
            tableHeaderStyle({row, column, rowIndex, columnIndex}) {
                if (rowIndex === 0) {
                    return `
                    background-color: #f0f4ff;
                    color: #5f719c;
                    height: 30px!important;
                    font-size: 14px;`
                }
            }
        }
    }
</script>
<style lang="scss">
    .timeTable{
        .cell{
            padding: 0 !important;
        }
        .borderBottom{
            padding-bottom: 10px;
            border-bottom: 1px solid #e5e5e5;
        }
        .paddingTop{
            padding-top: 10px;
        }
        .colorChange{
            color: #2b9dff;
        }
        .nP{
            padding-left: 10px;
            padding-right: 10px;
        }
    }
</style>
<style scoped lang="scss">
    .layout-box-white-bg-ig6pe {
        .caption-container-2Ll52.simple-2S7p1 {
            border-bottom: 1px solid #E6EAF5;
            font-size: 18px;
            padding: 22px 24px;

            span {
                font-size: 18px;
            }
        }

        .caption-container-2Ll52 {
            color: #373a44;
            position: relative;
            margin-bottom: 16px;
        }

        .illustrated-1fyrZ {
            display: flex;
            padding: 15px 25px;
            background-color: #F5F8FF;

            .pic-cover {
                margin-right: 40px;

                img {
                    max-width: 100%;
                }
            }

            .text-display {
                font-size: 14px;
                color: #96a2be;
                line-height: 22px;

                .desc {
                    padding-top: 10px;

                    p {
                        color: #50596f;
                        font-weight: 600;
                        margin-top: 16px;
                    }
                }
            }
        }



        .filter {
            margin-bottom: 25px;
            padding:24px;
            background: #ffffff;
            .ewt-tab-filter {
                font-size: 14px;
                .ewt-tab-filter-label {
                    color: #7c89a7;
                    line-height: 1;
                    float: left;
                    padding: 5px 0;
                }
                .ewt-tab-filter-content {
                    .ewt-tab-filter-li {
                        display: inline-block;
                        margin: 0 10px 12px 0;
                        border-radius: 4px;

                        .el-button {
                            border: none;
                            cursor: pointer;
                            padding: 5px 10px;
                            line-height: 1;
                        }
                    }
                }
            }
        }

        .course-timetable-2Sl4B {
            .operator {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 16px;
                position: relative;

                .btn {
                    font-size: 12px;
                    color: #50596f;
                    cursor: pointer;
                }

                .table-title {
                    margin: 0 24px;
                    font-size: 20px;
                    font-weight: 600;
                    color: #50596f;
                }

                .btn.disabled {
                    color: #DEE2F4;
                    cursor: not-allowed;
                }

                .icon-arrow-left-circle {
                    margin-left: 8px;
                    vertical-align: -6px;
                    font-size: 30px;
                }

                .icon-arrow-right-circle {
                    margin-right: 8px;
                    vertical-align: -6px;
                    font-size: 30px;
                }

                .export {
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 138px;
                    height: 32px;
                    border: 1px solid #5a8bff;
                    border-radius: 4px;
                    font-size: 14px;
                    color: #5a8bff;
                    line-height: 32px;
                    text-align: center;
                    cursor: pointer;
                    -webkit-user-select: none;
                    -moz-user-select: none;
                    -ms-user-select: none;
                    user-select: none;
                }
            }
        }

    }

</style>
